import storage from "./../storage";
export function getToken() {

    try {
        let logininfo = storage.get('logininfo');  //获取缓存信息
        if (!logininfo || !logininfo.token) {
            throw new Error("not fing logininfo");
        };
        // console.log(logininfo)
        return logininfo.token;
    }
    catch (e) {
        console.log(e);
    }
}


